import { RegularButton } from "@components/buttons"
import { LoginModal } from "@components/modal"
import { Container, FlexBox } from "@components/wrapper"
import { Disclosure, Tab, Transition } from "@headlessui/react"
import { CheckoutSummary } from "@interfaces/checkout"
import { SchoolDetail, SchoolProgram } from "@interfaces/school"
// import { AnalyticsProvider, useAnalytics } from "@lib/context/analytics"
import { useUserData } from "@lib/context/ComponentContext"
import { createMarkup, priceFormatter } from "@lib/functions"
import clsx from "clsx"
import Image from "next/image"
import { useRouter } from "next/router"
import React, { useState } from "react"
import { FaChevronDown } from "react-icons/fa"
import { IoMdCheckmark, IoMdClose } from "react-icons/io"
import { RiErrorWarningLine } from "react-icons/ri"
import Carousel from "react-multi-carousel"
import { BootcampSliderArrow } from "."
import { InstallmentModal } from "../general/InstallmentModal"
import { NotVerifiedEmailModal } from "../general/NotVerifiedEmailModal"
import { BootcampHeading } from "../general/ProgramHeading"

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
}

interface BootcampFeeProps {
  schoolDetail: SchoolDetail
  screenWidth: number
}

export const BootcampFee = ({ schoolDetail, screenWidth }: BootcampFeeProps) => {
  const [loginModal, setLoginModal] = useState(false)

  const [activeTab, setActiveTab] = useState(0)
  const [installmentModal, setInstallmentModal] = useState(false)
  const [emailVerifiedModal, setEmailVerifiedModal] = useState(false)
  const [installmentType, setInstallmentType] = useState("")

  const { isLogin, tokenData } = useUserData()
  const router = useRouter()
  const pathName = router.pathname
  // const { analytics } = useAnalytics()
  const { school_program_type, school_program_requirement, school_program_requirement_title } =
    schoolDetail

  const nextPageHandler = (data: SchoolProgram) => () => {
    // setPackageId(index)
    if (!isLogin) {
      return setLoginModal(true)
    }

    if (school_program_type[activeTab].program_type === "PAY_NOW") {
      try {
        const storage: CheckoutSummary = {
          school_id: schoolDetail.product_id,
          school_slug: schoolDetail.product_slug,
          school_title: schoolDetail.product_name,
          image: schoolDetail.product_asset.product_image,
          program_id: data.id,
          program_description: data.program_description,
          program_title: data.program_title,
          program_price: data.program_price,
          program_sku: data.program_sku,
        }

        if (tokenData.user_active) {
          const isProClass = pathName.includes("proclass")

          window.localStorage.setItem(
            isProClass ? "hsp_checkout" : "hs_checkout",
            JSON.stringify(storage)
          )

          // analytics.track("Product Clicked", {
          //   products: [
          //     {
          //       product_id: data.program_sku,
          //       name: `${schoolDetail.product_name} - ${data.program_title}`,
          //       affiliation: "PT. Karya Kaya Bahagia",
          //       coupon: "",
          //       discount: 0,
          //       currency: "IDR",
          //       brand: "HMS",
          //       category: isProClass ? "ProClass" : "Bootcamp",
          //       variant: data.program_title,
          //       price: data.program_price,
          //       quantity: 1,
          //       position: 0,
          //       item_list_name: schoolDetail.product_name,
          //       item_list_id: schoolDetail.product_id,
          //     },
          //   ],
          //   item_list_name: schoolDetail.product_name,
          //   item_list_id: schoolDetail.product_id,
          // })

          window.location.assign(`/school/${isProClass ? "proclass/checkout" : "checkout"}`)
        } else {
          setEmailVerifiedModal(true)
          // alert(
          //   "Akun kamu belum diverifikasi. silahkan coba login ulang jika kamu telah melakukan verikasi"
          // )
        }
      } catch (e) {
        alert(e)
        alert("Terjadi kesalahan. Silahkan coba login ulang dan coba lagi")
      }
    }

    if (school_program_type[activeTab].program_type === "INSTALLMENT") {
      setInstallmentType(data?.program_title === "Danacita" ? "Danacita" : "Harisenin")
      return setInstallmentModal(true)
      // return window.open(
      //   // `https://api.whatsapp.com/send?phone=6281312117711&text=Saya%20Mau%20ikut%Program%20Cicilan%20di%20harisenin.com%20min`,
      //   "https://harisenin.link/cYNE1",
      //   "_blank"
      // )
    }
  }

  if (!school_program_type || !school_program_type.length) {
    return <></>
  }

  const payNowPrograms = school_program_type[0].school_programs
  const installments = school_program_type.length > 1 ? school_program_type[1].school_programs : []

  const ProgramCard = ({ sch }) => (
    <div>
      <div
        key={sch.id}
        className={clsx("bg-white card-box rounded-lg grid h-fit", "sm:p-9 gap-6", "p-5")}
      >
        <div className="grid sm:gap-4 gap-2">
          <FlexBox className="gap-2.5 sm:h-8 justify-between sm-only:items-center">
            <div
              className={clsx(
                "font-urbanist text-primary-black font-bold line-clamp-1 ",
                "sm:text-2xl",
                Boolean(sch.program_best_seller) && "sm:w-3/5"
              )}
              title={sch.program_title}
            >
              {sch.program_title}
            </div>

            {Boolean(sch.program_best_seller) && (
              <div
                className={clsx(
                  "flex text-new-green rise-background text-xs rounded font-bold",
                  "p-2.5"
                )}
              >
                Best Seller ⭐
              </div>
            )}
          </FlexBox>
          <div
            dangerouslySetInnerHTML={createMarkup(sch.program_description)}
            className="text-secondary-grey h-[3em]"
          />
        </div>

        <div className="grid sm:gap-2">
          {sch.program_discount_percentage ? (
            <FlexBox className="gap-2.5" align="center">
              <div
                className={clsx(
                  "sm:w-[110px] text-error error-background text-xs rounded font-bold",
                  "sm:p-2.5 px-2.5 py-2"
                )}
              >
                Diskon {sch.program_discount_percentage}% 🔥{" "}
              </div>
              <div className="text-disabled-grey line-through">
                {priceFormatter(sch.program_original_price)}
              </div>
            </FlexBox>
          ) : (
            <div className="h-9" />
          )}

          <div
            className={clsx(
              "font-urbanist font-bold text-primary-black",
              "sm:text-[32px] text-2xl"
            )}
          >
            {priceFormatter(sch.program_price)}
          </div>
        </div>

        <div className="grid gap-4">
          <RegularButton
            variant={"new-blue"}
            disabled={!sch.can_order}
            className="!rounded-lg h-fit w-full"
            customPadding="py-3"
            onClick={nextPageHandler(sch)}
          >
            {sch.can_order ? "Daftar Sekarang" : "Sold Out"}
          </RegularButton>
          {school_program_type.length > 1 && (
            <RegularButton
              variant={"light-blue"}
              disabled={!sch.can_order}
              className="!rounded-lg h-fit w-full"
              customPadding="py-3"
              onClick={() => setActiveTab(1)}
            >
              Daftar dengan Cicilan
            </RegularButton>
          )}
        </div>

        {Boolean(sch.program_benefits) && (
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex justify-between items-center">
                  <div className="text-black-22">Benefit</div>
                  <FaChevronDown
                    className={open ? "rotate-180 transform text-new-blue" : "text-[#3A35418A]"}
                  />
                </Disclosure.Button>
                <Transition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel static>
                    <div className={clsx("grid gap-4")}>
                      {sch.program_benefits.map((d, i) => (
                        <div key={i}>
                          <FlexBox key={i} className="gap-3">
                            <div className="w-6 mt-0.5 text-xl">
                              {d.benefit_icon === "true-green" && (
                                <IoMdCheckmark className="text-blue" />
                              )}
                              {d.benefit_icon === "no" && <IoMdClose className="text-error" />}
                            </div>
                            <div className="w-[90%] sm-only:text-sm">{d.benefit_title}</div>
                          </FlexBox>
                        </div>
                      ))}
                    </div>
                  </Disclosure.Panel>
                </Transition>
              </>
            )}
          </Disclosure>
        )}
      </div>
    </div>
  )

  return (
    // <AnalyticsProvider>
    <>
      <div className="sm:py-20 py-10 bg-body-bg relative">
        <Container className="relative">
          <div className="relative sm:mb-9 mb-6">
            <BootcampHeading
              id="fee"
              title="Kategori & biaya"
              subTitle="Apa Saja Program dan Benefit yang Ditawarkan?"
            />
          </div>

          <Tab.Group selectedIndex={activeTab}>
            {/* Tab for program category */}
            {school_program_type.length > 1 && (
              <Tab.List
                className={clsx(
                  `grid grid-cols-${school_program_type.length}`,
                  "sm:mb-9 mb-[18px]"
                )}
              >
                {school_program_type.map((value, index) => (
                  <Tab
                    key={index}
                    onClick={() => setActiveTab(index)}
                    className={({ selected }) =>
                      clsx(
                        "py-4 font-medium",
                        selected
                          ? "text-blue bg-[#EBEFFC] border-b-blue border-b-3"
                          : "border-b-new-grey border-b"
                      )
                    }
                  >
                    {value.program_type_alias}
                  </Tab>
                ))}
              </Tab.List>
            )}

            <Tab.Panels className="">
              <Tab.Panel>
                <div className={clsx("grid sm:gap-9 gap-6", "sm:grid-cols-1")}>
                  {screenWidth > 576 && (
                    <Carousel
                      responsive={responsive}
                      ssr={true} // means to render carousel on server-side.
                      containerClass={clsx("sm:-ml-4.5 sm:mb-9 mb-4")}
                      itemClass="sm:px-4.5 px-4"
                      arrows={false}
                      {...(screenWidth > 576 && {
                        customButtonGroup: (
                          <BootcampSliderArrow
                            length={payNowPrograms.length}
                            displayedSlide={3}
                            className="justify-between sm:-ml-6 absolute top-96"
                          />
                        ),
                        renderButtonGroupOutside: true,
                        partialVisible: true,
                      })}
                      className="d-lg-flex d-none"
                    >
                      {payNowPrograms.map((sch) => (
                        <ProgramCard sch={sch} key={sch.id} />
                      ))}
                    </Carousel>
                  )}

                  {screenWidth < 576 &&
                    payNowPrograms.map((sch) => <ProgramCard sch={sch} key={sch.id} />)}
                </div>
                {school_program_requirement && (
                  <div
                    className={clsx(
                      "border border-new-grey rounded-lg bg-white",
                      "sm:p-9 sm:mt-9",
                      "py-3 px-[14px] mb-4 mt-[18px]"
                    )}
                  >
                    <FlexBox align="center" className="text-xl gap-2 mb-3">
                      <RiErrorWarningLine className="text-new-blue text-xl" />
                      <span className="sm:text-xl text-base">
                        <div
                          dangerouslySetInnerHTML={createMarkup(school_program_requirement_title)}
                          className="markup-title"
                        />
                      </span>
                    </FlexBox>
                    <div
                      dangerouslySetInnerHTML={createMarkup(school_program_requirement)}
                      className="sm-only:text-xs markup with-list"
                    />
                  </div>
                )}
              </Tab.Panel>

              {school_program_type.length > 1 && (
                <Tab.Panel>
                  <div
                    className={clsx(
                      "grid sm:gap-9 gap-6",
                      payNowPrograms.length === 2 && "sm:grid-cols-2",
                      payNowPrograms.length === 3 && "sm:grid-cols-3"
                    )}
                  >
                    {installments.map((int) => (
                      <div
                        key={int.id}
                        className={clsx(
                          "bg-white card-box rounded-lg grid h-fit",
                          "sm:p-9 gap-6",
                          "p-5"
                        )}
                      >
                        <div className="grid gap-4">
                          <FlexBox className="gap-2.5 sm:h-8" align="center">
                            <div>
                              <Image
                                src={int.program_type_logo ?? ""}
                                width={64}
                                height={64}
                                alt={int.program_title}
                              />
                            </div>
                            <div
                              className={clsx(
                                "font-urbanist text-primary-black font-bold line-clamp-1",
                                "sm:text-2xl"
                              )}
                              title={int.program_title}
                            >
                              {int.program_title}
                            </div>
                          </FlexBox>

                          <div
                            dangerouslySetInnerHTML={createMarkup(int.program_description)}
                            className="text-secondary-grey"
                          />
                        </div>
                        <div className="grid gap-4">
                          <RegularButton
                            variant={"new-blue"}
                            disabled={!int.can_order}
                            className="!rounded-lg h-fit w-full"
                            customPadding="py-3"
                            onClick={nextPageHandler(int)}
                          >
                            Daftar Cicilan
                          </RegularButton>
                        </div>
                      </div>
                    ))}
                  </div>
                </Tab.Panel>
              )}
              {/* <Tab.Panel></Tab.Panel> */}
            </Tab.Panels>
          </Tab.Group>
        </Container>
      </div>

      <LoginModal onHide={() => setLoginModal(false)} show={loginModal} />
      <InstallmentModal
        onHide={() => setInstallmentModal(false)}
        show={installmentModal}
        type={installmentType}
      />
      <NotVerifiedEmailModal
        onHide={() => setEmailVerifiedModal(false)}
        show={emailVerifiedModal}
      />
    </>
    // </AnalyticsProvider>
  )
}
